import { API_HOST } from 'lib'
import { authenticatedFetch } from 'lib/authenticatedGet'

export type OverrideHistoryEntry = {
  id: number
  assortmentType: string
  recordedAt: string
  effectiveUntil: string | null
  reason: string
  createdBy: string | null
  counts: Record<string, number>
}

export type OverrideSnapshot = {
  entry: OverrideHistoryEntry
  modifications: Record<string, { referenceObjectId: string; actionType: string; actionValue: string }[]>
}

export type OverrideRecoveryPreview = {
  snapshot: OverrideSnapshot
  currentCommonId: string | null
  contextVersion: string
  recoverable: boolean
  issues: string[]
}

const base = (installationId: string) => `${API_HOST}/v1/installation/${installationId}/override-history`

export const listOverrideHistory = async (installationId: string, filters: URLSearchParams, signal: AbortSignal) => {
  const response = await authenticatedFetch<{ data: OverrideHistoryEntry[] }>(`${base(installationId)}?${filters}`, {
    method: 'GET',
    signal,
  })
  return response.data
}

export const getOverrideSnapshot = async (installationId: string, id: number, signal: AbortSignal) => {
  const response = await authenticatedFetch<{ data: OverrideSnapshot }>(`${base(installationId)}/${id}`, {
    method: 'GET',
    signal,
  })
  return response.data
}

export const previewOverrideRecovery = async (installationId: string, id: number, signal: AbortSignal) => {
  const response = await authenticatedFetch<{ data: OverrideRecoveryPreview }>(
    `${base(installationId)}/${id}/preview`,
    {
      method: 'POST',
      signal,
    },
  )
  return response.data
}

export const recoverOverrides = async (installationId: string, id: number, contextVersion: string) => {
  await authenticatedFetch(
    `${base(installationId)}/${id}/recover`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ contextVersion }),
    },
    0,
  )
}
